// extracted by mini-css-extract-plugin
export var betaBadge = "style-module--betaBadge--d1a64";
export var companyLinks = "style-module--companyLinks--ecd7f";
export var footerCompanyDetails = "style-module--footerCompanyDetails--f3044";
export var footerContainer = "style-module--footerContainer--5c679";
export var footerContent = "style-module--footerContent--a80ec";
export var footerLinks = "style-module--footerLinks--13600";
export var linkContainer = "style-module--linkContainer--846f1";
export var logoContainer = "style-module--logoContainer--b5224";
export var sitterLink = "style-module--sitterLink--0ed43";
export var trademark = "style-module--trademark--503fc";